import { render } from "./AddOrUpdateCommunity.vue?vue&type=template&id=b6795ec2&scoped=true"
import script from "./AddOrUpdateCommunity.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateCommunity.vue?vue&type=script&lang=js"

import "./AddOrUpdateCommunity.vue?vue&type=style&index=0&id=b6795ec2&lang=css"
import "./AddOrUpdateCommunity.vue?vue&type=style&index=1&id=b6795ec2&scoped=true&lang=css"
import "./AddOrUpdateCommunity.vue?vue&type=style&index=2&id=b6795ec2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6795ec2"]])

export default __exports__